document.addEventListener('DOMContentLoaded', function() {
  const filterItems = document.querySelectorAll('.filter__item');
  
  if (filterItems.length === 0) return;

  // Function to apply filter
  function applyFilter(filterValue) {
    // Get all sections on the page with data-filter attribute
    const filterableSections = document.querySelectorAll('[data-filter]');
    
    filterableSections.forEach(function(section) {
      const sectionFilterValue = section.getAttribute('data-filter');
      
      // Skip sections with empty data-filter attribute
      if (!sectionFilterValue || sectionFilterValue.trim() === '') {
        return;
      }
      
      // Show/hide based on filter match or "all" filter
      // Also show sections with data-filter="all" in all filters
      if (filterValue === 'all' || sectionFilterValue === filterValue || sectionFilterValue === 'all') {
        section.style.display = '';
      } else {
        section.style.display = 'none';
      }
    });
  }

  // Apply initial filter on page load
  const activeFilter = document.querySelector('.filter__item.active');
  if (activeFilter) {
    const initialFilterValue = activeFilter.getAttribute('data-filter-value');
    applyFilter(initialFilterValue);
  }

  // Add click handlers to all filter items
  filterItems.forEach(function(filterItem) {
    filterItem.addEventListener('click', function() {
      // Remove active class from all filters
      filterItems.forEach(function(item) {
        item.classList.remove('active');
      });
      
      // Add active class to clicked filter
      this.classList.add('active');
      
      // Get the filter value and apply filter
      const filterValue = this.getAttribute('data-filter-value');
      applyFilter(filterValue);
    });
  });
});
